module.exports = __webpack_public_path__ + "img/kapila-siriwardhana-leccturing-02-small.99c39ab1.jpg";